// extracted by mini-css-extract-plugin
export var outergrid = "FeaturesConHero-module--outergrid--b4346";
export var outergridcol = "FeaturesConHero-module--outergridcol--dc7a9";
export var title = "FeaturesConHero-module--title--2a780";